// import 'babel-polyfill'
import 'react-app-polyfill/ie11'

import React from 'react'

// Root Component
import App from '@components/App'
import LPVivazConnection from '../components/containers/LPVivazConnection'

// Components Containers

const Home = React.lazy(() => import('@components/containers/Home'))

const Advantages = React.lazy(() => import('@components/containers/Advantages'))

const NotFound = React.lazy(() => import('@components/containers/NotFound'))

const About = React.lazy(() => import('@components/containers/About'))

const PressRoom = React.lazy(() => import('@components/containers/PressRoom'))

const Faq = React.lazy(() => import('@components/containers/Faq'))

const FaqDetails = React.lazy(() => import('@components/containers/FaqDetails'))

const Contact = React.lazy(() => import('@components/containers/Contact'))

const HouseVivaz = React.lazy(() => import('@components/containers/HouseVivaz'))

const StoreMap = React.lazy(() => import('@components/containers/StoreMap'))

// const EstateAgent = React.lazy(() => import('@components/containers/EstateAgent'))

const Terms = React.lazy(() => import('@components/containers/Terms'))

const Apartments = React.lazy(() => import('@components/containers/Apartments'))

const Campaigns = React.lazy(() => import('@components/containers/Campaigns'))

const Simulator = React.lazy(() => import('@components/containers/Simulator'))

const SimulatorHome = React.lazy(() => import('@components/children/simulator/SimulatorHome'))

const SimulatorStep1 = React.lazy(() => import('@components/children/simulator/SimulatorStep1'))

const SimulatorStep2 = React.lazy(() => import('@components/children/simulator/SimulatorStep2'))

const SimulatorResult = React.lazy(() => import('@components/children/simulator/SimulatorResult'))

const Product = React.lazy(() => import('@components/containers/Product'))

const Realtor = React.lazy(() => import('@components/containers/Realtor'))

const ProductLocation = React.lazy(() => import('@components/containers/ProductLocation'))

const Neighborhood = React.lazy(() => import('@components/containers/Neighborhood'))

const LandingPage = React.lazy(() => import('@components/containers/LandingPage'))

const CyrelaInstitute = React.lazy(() => import('@components/containers/CyrelaInstitute'))

const Simulador = React.lazy(() => import('@components/containers/Simulador'))

const SimuladorHome = React.lazy(() => import('@components/children/Simulador/SimuladorHome'))

const SimuladorSucesso = React.lazy(() => import('@components/children/Simulador/SimuladorSucesso'))

const SimuladorAnoNovo = React.lazy(() => import('@components/children/Simulador/SimuladorAnoNovo'))

export default [
  {
    component: App,
    routes: [
      {
        path: '/',
        component: Home,
        exact: true,
        type: 'home',
      },
      {
        path: '/vivantagens-:state',
        component: Advantages,
        exact: true,
        type: 'vivantagens',
      },
      {
        path: '/outlet',
        component: (props) => {
          window.location.href = `https://lp.meuvivaz.com.br/outlet-turbo${props.location.search}`
          return null
        },
        exact: true,
        type: 'outlet',
      },
      {
        path: '/mercadogratis',
        component: (props) => {
          window.location.href = `https://materiais.meuvivaz.com.br/mercadogratis${props.location.search}`
          return null
        },
        exact: true,
        type: 'mercadogratis',
      },
      {
        path: '/entradaemdobro',
        component: (props) => {
          window.location.href = `http://materiais.meuvivaz.com.br/entradaemdobro${props.location.search}`
          return null
        },
        exact: true,
        type: 'entradaemdobro',
      },
      {
        path: '/caminhaodepremios',
        component: (props) => {
          window.location.href = `https://materiais.meuvivaz.com.br/caminhaodepremios${props.location.search}`
          return null
        },
        exact: true,
        type: 'caminhaodepremios',
      },
      {
        path: '/mascote',
        component: (props) => {
          window.location.href = `https://materiais.meuvivaz.com.br/mascote${props.location.search}`
          return null
        },
        exact: true,
        type: 'mascote',
      },
      /* {
        path: '/casavivaz',
        component: (props) => {
          window.location.href = `https://materiais.meuvivaz.com.br/casa-vivaz${props.location.search}`
          return null
        },
        exact: true,
        type: 'casavivaz',
      }, */
      {
        path: '/feiraodahora',
        component: (props) => {
          window.location.href = `https://materiais.meuvivaz.com.br/feirao2021${props.location.search}`
          return null
        },
        exact: true,
        type: 'feiraodahora',
      },
      {
        path: '/vale100',
        component: (props) => {
          window.location.href = `https://img.cyrela.com.br/regulamento/vivaz/01-04-2021-15-54-08-408802-regulamento-promocao-vale.pdf${props.location.search}`
          return null
        },
        exact: true,
      },
      {
        path: '/caminhaodepremios-regulamento',
        component: (props) => {
          window.location.href = `https://img.cyrela.com.br/campanhas-vivaz/2020/julho/regulamento-vivaz-aniversario.pdf${props.location.search}`
          return null
        },
        exact: true,
      },
      {
        path: '/regulamentofeiraocomprafacil',
        component: (props) => {
          window.location.href = `https://img.cyrela.com.br/regulamento/vivaz/03-11-2020-13-59-37-286758-regulamento-feirao-compra-facil-decimo-terceiro-em-dobro-vivaz-no....pdf${props.location.search}`
          return null
        },
        exact: true,
      },
      {
        path: '/promocao14salario',
        component: (props) => {
          window.location.href = `https://cdn.cyrela.com.br/Files/LandingPagesPadrao/mote-vivaz/SP.+Regulamento+-+DECIMO+QUARTO+SAL%C3%81RIO+EM+DESCONTO+-+Vivaz+Janeiro_2021+-+RIO+DE+JANEIRO.pdf${props.location.search}`
          return null
        },
        exact: true,
      },
      {
        path: '/promocao14salariorj',
        component: (props) => {
          window.location.href = `https://s3-app-cyrela.s3.amazonaws.com/Files/LandingPagesPadrao/mote-vivaz/Regulamento+-+DECIMO+QUARTO+SAL%C3%81RIO+EM+DESCONTO+-+Vivaz+Janeiro_2021+-+RIO+DE+JANEIRO_PDF_2.pdf${props.location.search}`
          //window.location.href = `https://cdn.cyrela.com.br/Files/LandingPagesPadrao/mote-vivaz/RJ.+Regulamento+-+DECIMO+QUARTO+SAL%C3%81RIO+EM+DESCONTO+-+Vivaz+Janeiro_2021+-+RIO+DE+JANEIRO.pdf${props.location.search}`
          return null
        },
        exact: true,
      },
      {
        path: '/feiraodaindependecia',
        component: (props) => {
          window.location.href = `https://img.cyrela.com.br/campanhas-vivaz/2020/agosto/regulamento-entrada-em-dobro-vivaz-setembro2020.pdf${props.location.search}`
          return null
        },
        exact: true,
      },
      {
        path: '/mascote-regulamento',
        component: (props) => {
          window.location.href = `https://img.cyrela.com.br/campanhas-vivaz/2020/agosto/regulamento_lancamento_mascote.pdf${props.location.search}`
          return null
        },
        exact: true,
      },
      {
        path: '/comprafacil',
        component: (props) => {
          window.location.href = `https://img.cyrela.com.br/campanhas-vivaz/2020/julho/regulamento-compra-facil-vivaz.pdf${props.location.search}`
          return null
        },
        exact: true,
      },
      {
        path: '/rendamais',
        component: (props) => {
          window.location.href = `https://lp.meuvivaz.com.br/renda-mais${props.location.search}`
          return null
        },
        exact: true,
      },
      {
        path: '/casinhavivaz',
        component: (props) => {
          window.location.href = `https://lp.meuvivaz.com.br/casa-vivaz${props.location.search}`
          return null
        },
        exact: true,
      },
      {
        path: '/placarpremiadovivaz',
        component: (props) => {
          window.location.href = `https://lp.meuvivaz.com.br/copa-vivaz${props.location.search}`
          return null
        },
        exact: true,
      },
      {
        path: '/aniversario',
        component: (props) => {
          window.location.href = 'https://lp.meuvivaz.com.br/aniversário-vivaz-5'
          return null
        },
        exact: true,
        type: 'aniversario',
      },

      // REDIRECTS APARTAMENTOS
      {
        path: '/apartamento/vivaz-prime-belem-apartamento-belenzinho-zona-sul-sao-paulo-sp',
        component: (props) => {
          props.history.push('/apartamento/vivaz-prime-belem-apartamento-belenzinho-zona-leste-sao-paulo-sp')
          return null
        },
        exact: true,
      },
      {
        path: '/apartamento/vivaz-estacao-belem-2-apartamento-belenzinho-zona-sul-sao-paulo-sp',
        component: (props) => {
          props.history.push('/apartamento/vivaz-estacao-belem-2-apartamento-belenzinho-zona-leste-sao-paulo-sp')
          return null
        },
        exact: true,
      },
      {
        path: '/apartamento/vivaz-cantareira-apartamento-pirituba-zona-oeste-sao-paulo-sp ',
        component: (props) => {
          props.history.push('/apartamento/vivaz-cantareira-apartamento-pirituba-zona-norte-sao-paulo-sp')
          return null
        },
        exact: true,
      },
      {
        path: '/apartamento/vivaz-jardim-pirituba-II-apartamento-jardim-pirituba-zona-oeste-sao-paulo-sp',
        component: (props) => {
          props.history.push('/apartamento/vivaz-jardim-pirituba-II-apartamento-jardim-pirituba-zona-norte-sao-paulo-sp')
          return null
        },
        exact: true,
      },
      {
        path: '/apartamento/vivaz-bandeirantes-apartamento-jacarepagua-zona-oeste-rio-de-janeiro-rj',
        component: (props) => {
          props.history.push('/apartamento/vivaz-prime-bandeirantes-jacarepagua-apartamento-jacarepagua-zona-oeste-rio-de-janeiro-rj')
          return null
        },
        exact: true,
      },
      {
        path: '/apartamento/vivaz-itaquera-apartamento-itaquera-centro-sao-paulo-sp',
        component: (props) => {
          props.history.push('/apartamento/vivaz-itaquera-apartamento-itaquera-zona-leste-sao-paulo-sp')
          return null
        },
        exact: true,
      },

      // Redirect url antiga simulador
      {
        path: '/simulador-cva-mcmv/:path',
        component: (props) => window.location.href = `/simulador/${props.match.params.path}${props.location.search}`,
        exact: true,
      },
      {
        path: '/simulador-cva-mcmv',
        component: (props) => window.location.href = `/simulador${props.location.search}`,
        exact: true,
      },
      // Redirect url antiga simulador
      {
        path: '/simulador-mcmv/:path',
        component: (props) => window.location.href = `/simulador/${props.match.params.path}${props.location.search}`,
        exact: true,
      },
      {
        path: '/simulador-mcmv',
        component: (props) => window.location.href = `/simulador${props.location.search}`,
        exact: true,
      },
      // #############################
      {
        path: '/contato',
        component: Contact,
        exact: true,
        type: 'contato',
      },
      {
        path: '/casavivaz',
        component: HouseVivaz,
        exact: true,
        type: 'casa-vivaz',
      },
      {
        path: '/mapa-de-lojas',
        component: StoreMap,
        exact: true,
        type: 'mapa-de-lojas',
      },
      {
        path: '/indique',
        component: NotFound,
        exact: true,
        type: 'indique',
      },
      {
        path: '/termos-privacidade',
        component: Terms,
        exact: true,
        type: 'termos-privacidade',
      },
      {
        path: '/duvidas-frequentes',
        component: Faq,
        exact: true,
        type: 'duvidas-frequentes',
      },
      {
        path: '/duvidas-frequentes/:question',
        component: FaqDetails,
        exact: true,
        type: 'duvidas-frequentes',
      },
      {
        path: '/apartamentos/:apartments',
        component: Apartments,
        exact: true,
        type: 'categoria',
      },
      {
        path: '/apartamentos/:apartments/todos/:neighborhood',
        component: Apartments,
        exact: true,
        type: 'categoria',
      },
      {
        path: '/:city/bairros/:neighborhood',
        component: Neighborhood,
        exact: true,
        type: 'bairros',
      },
      {
        path: '/campanhas/:campaign',
        component: Campaigns,
        exact: true,
        type: 'campanhas',
      },
      {
        path: '/simulador',
        component: Simulador,
        routes: [

          // Campanha Ano Novo
          {
            path: '/simulador/ano-novo-casa-nova',
            component: SimuladorAnoNovo,
          },

          // Simulador Normal
          {
            path: '/simulador/sucesso',
            component: SimuladorSucesso,
          },
          {
            path: '',
            component: SimuladorHome,
          },
        ],
        type: 'simulador',
      },
      {
        path: '/apartamento/:product',
        component: Product,
        exact: true,
        type: 'imovel',
      },
      {
        path: '/vendedor/:product',
        component: Realtor,
        exact: true,
        type: 'vendedor',
      },
      {
        path: '/apartamento/:product/localizacao',
        component: ProductLocation,
        exact: true,
        type: 'imovel-localizacao',
      },
      {
        path: '/lp/conexao-vivaz',
        component: LPVivazConnection,
        exact: true,
        type: 'conexao-vivaz',
      },
      {
        path: '/lp/indique',
        component: NotFound,
        exact: true,
        type: 'indique',
      },
      {
        path: '/lp/:landingpage',
        component: LandingPage,
        exact: true,
        type: ':landingpage',
      },
      {
        path: '/simulador-cva-mcmv',
        component: Simulator,
        routes: [
          {
            path: '/simulador-cva-mcmv/passo1',
            component: SimulatorStep1,
          },
          {
            path: '/simulador-cva-mcmv/passo2',
            component: SimulatorStep2,
          },
          {
            path: '/simulador-cva-mcmv/resultado',
            component: SimulatorResult,
          },
          {
            path: '',
            component: SimulatorHome,
          },
        ],
        type: 'simulador-cva-mcmv',
      },
      {
        path: '/sobre-nos',
        component: About,
        exact: true,
        type: 'sobre-nos',
      },
      {
        path: '/sala-de-imprensa',
        component: PressRoom,
        exact: true,
        type: 'sala-de-imprensa',
      },
      /* {
        path: '/corretores-e-imobiliarias',
        component: EstateAgent,
        exact: true,
        type: 'corretores-e-imobiliarias',
      }, */
      {
        path: '/instituto-cyrela',
        component: CyrelaInstitute,
        exact: true,
        type: 'instituto-cyrela',
      },
      {
        path: '/:product',
        component: Product,
        exact: true,
        type: 'imovel',
      },
      {
        path: '/*',
        component: (props) => {
          if (!props.location.pathname.includes('erro-404')) {
            props.history.push(`/erro-404${props.location.pathname}`) //arrumar loop infinito
          }
          return <NotFound />
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/config/router.js